/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDuplicateEntryResponse
 */
export interface RevisdomAPIViewModelsEntryDuplicateEntryResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryResponse
     */
    newEntryId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryResponse
     */
    entryType?: RevisdomAPIViewModelsEntryDuplicateEntryResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryResponse
     */
    path?: string | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryDuplicateEntryResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryDuplicateEntryResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryDuplicateEntryResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryDuplicateEntryResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDuplicateEntryResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDuplicateEntryResponse(value: object): value is RevisdomAPIViewModelsEntryDuplicateEntryResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSON(json: any): RevisdomAPIViewModelsEntryDuplicateEntryResponse {
    return RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDuplicateEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'newEntryId': json['newEntryId'] == null ? undefined : json['newEntryId'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
    };
}

export function RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSON(json: any): RevisdomAPIViewModelsEntryDuplicateEntryResponse {
    return RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryDuplicateEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newEntryId': value['newEntryId'],
        'entryType': value['entryType'],
        'name': value['name'],
        'path': value['path'],
    };
}

